// Яндекс-карта офисов: у филиалов в ACF нет координат, поэтому адреса
// геокодируются на клиенте (геокодер входит в JS API 2.1) с кэшем в localStorage.
const DEFAULT_CENTER = [41.311158, 69.279737]; // Ташкент
const DEFAULT_ZOOM = 10;
const SINGLE_POINT_ZOOM = 13;
const STORAGE_PREFIX = "officesMapGeo:";

const PIN_TEMPLATE =
    '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="68" viewBox="0 0 42 68"' +
    ' style="position:absolute;left:-21px;top:-66px;pointer-events:none;">' +
    '<use xlink:href="#icon-map-pin"></use>' +
    "</svg>";

// Кликабельная зона метки (iconShape) в координатах относительно точки привязки
const PIN_SHAPE = {
    type: "Rectangle",
    coordinates: [[-21, -66], [21, 0]]
};

const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (ch) => ({
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    })[ch]);

const readCache = (query) => {
    try {
        const raw = localStorage.getItem(STORAGE_PREFIX + query);

        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

const writeCache = (query, coords) => {
    try {
        localStorage.setItem(STORAGE_PREFIX + query, JSON.stringify(coords));
    } catch (e) {
        // storage переполнен/запрещён — просто геокодим заново в следующий раз
    }
};

const geocodeQuery = (query) => {
    const cached = readCache(query);

    if (cached) {
        return Promise.resolve(cached);
    }

    return ymaps.geocode(query, { results: 1 }).then((res) => {
        const geoObject = res.geoObjects.get(0);

        if (!geoObject) {
            return null;
        }

        const coords = geoObject.geometry.getCoordinates();

        writeCache(query, coords);

        return coords;
    }).catch(() => null);
};

// «ТК „…“, магазин № …. Ориентир: …» геокодер не понимает — оставляем улицу и дом
const simplifyAddress = (address) => address
    .replace(/ориентир.*$/i, "")
    .replace(/[«"][^»"]*[»"]/g, "")
    .replace(/магазин\s*№?\s*[\w/-]+/gi, "")
    .replace(/\s{2,}/g, " ")
    .replace(/[,.\s]+$/g, "");

// Регион в запросе повышает точность; если с ним ничего не нашлось —
// пробуем без него, затем с упрощённым адресом
const geocodeAddress = (cityTitle, address) => {
    const simplified = simplifyAddress(address);

    return geocodeQuery("Узбекистан, " + cityTitle + ", " + address)
        .then((coords) => coords || geocodeQuery("Узбекистан, " + address))
        .then((coords) => coords || (simplified !== address
            ? geocodeQuery("Узбекистан, " + cityTitle + ", " + simplified)
            : null));
};

const balloonHtml = (branch, address) => {
    const phones = (branch.phones || []).map((phone) =>
        '<a href="tel:' + phone.replace(/[^+0-9]/g, "") + '">' + escapeHtml(phone) + "</a>"
    ).join("");

    return '<div class="offices-page__map-balloon">' +
        '<div class="offices-page__map-balloon-title">' + escapeHtml(branch.title) + "</div>" +
        '<div class="offices-page__map-balloon-address">' + escapeHtml(address) + "</div>" +
        (phones ? '<div class="offices-page__map-balloon-phones">' + phones + "</div>" : "") +
        "</div>";
};

export const createOfficesMap = ($map, cities) => {
    if (!$map || !cities.length || typeof window.ymaps === "undefined") {
        return null;
    }

    let map = null;
    let pinLayout = null;
    let pendingIndex = 0;
    let requestId = 0;

    const render = (index) => {
        const id = ++requestId;
        const city = cities[index];
        const points = [];

        (city.branches || []).forEach((branch) => {
            (branch.addresses || []).forEach((address) => {
                points.push({ branch, address });
            });
        });

        Promise.all(points.map((point) =>
            geocodeAddress(city.title, point.address)
                .then((coords) => (coords ? { ...point, coords } : null))
        )).then((results) => {
            // город успели переключить — эти метки уже не нужны
            if (id !== requestId) {
                return;
            }

            map.geoObjects.removeAll();

            const found = results.filter(Boolean);

            found.forEach(({ branch, address, coords }) => {
                map.geoObjects.add(new ymaps.Placemark(coords, {
                    hintContent: branch.title,
                    balloonContent: balloonHtml(branch, address)
                }, {
                    iconLayout: pinLayout,
                    iconShape: PIN_SHAPE,
                    hideIconOnBalloonOpen: false,
                    balloonOffset: [0, -58]
                }));
            });

            if (found.length > 1) {
                map.setBounds(map.geoObjects.getBounds(), { checkZoomRange: true, zoomMargin: 48 });
            } else if (found.length === 1) {
                map.setCenter(found[0].coords, SINGLE_POINT_ZOOM, { checkZoomRange: true });
            }
        });
    };

    const showCity = (index) => {
        pendingIndex = index;

        if (map) {
            render(index);
        }
    };

    ymaps.ready(() => {
        map = new ymaps.Map($map, {
            center: DEFAULT_CENTER,
            zoom: DEFAULT_ZOOM,
            controls: ["zoomControl"]
        }, {
            suppressMapOpenBlock: true,
            autoFitToViewport: "always" // контейнер меняет размер на брейкпоинтах/повороте
        });

        pinLayout = ymaps.templateLayoutFactory.createClass(PIN_TEMPLATE);

        render(pendingIndex);
    });

    return { showCity };
};
